import './serp';
import '@seo/js/partials/header/header-new/_header';
import initEmailAlertForm from '../../js/partials/_email-alert-form';

import '@seo/css/dirp/desktop.less';

initEmailAlertForm();
